export const textColor = '#677380'
export const axisLineColor = '#D9D9D9'
export const fontSizeLarge = 14
export const colorList = ['#4A9EFF', '#4ECCCC', '#FDD54F', '#F4657D', '#9961E9']
